import React from "react";
import { Flex, Switch, Text, Badge } from "@radix-ui/themes";
import "./sevenroomsLayout.css";

export const SEVENROOMS_PULL_FIELDS = [
  "First name",
  "Last name",
  "Email",
  "Phone",
  "Gender",
];

export function SevenRoomsSyncDirectionsSection({
  pushChecked,
  pullChecked,
  onPushCheckedChange,
  onPullCheckedChange,
  disabled = false,
}) {
  return (
    <div className="sr-stack">
      <Flex align="center" justify="between" gap="4" wrap="wrap">
        <Text size="2" weight="medium">
          Push WiFi guests to SevenRooms
        </Text>
        <Switch
          size="2"
          checked={Boolean(pushChecked)}
          disabled={disabled}
          onCheckedChange={onPushCheckedChange}
        />
      </Flex>
      <Text size="1" color="gray">
        Create or update SevenRooms clients from WiFi connections at mapped locations,
        including the configured tag and WiFi visit note. When this is turned back
        on, choose whether to resume from the last sync or start from now.
      </Text>

      <Flex align="center" justify="between" gap="4" wrap="wrap">
        <Text size="2" weight="medium">
          Pull SevenRooms guests into Contacts
        </Text>
        <Switch
          size="2"
          checked={Boolean(pullChecked)}
          disabled={disabled}
          onCheckedChange={onPullCheckedChange}
        />
      </Flex>
      <Text size="1" color="gray">
        Copy guest profiles from mapped SevenRooms venues into Contacts. Each time
        this is enabled after being off, choose whether to import existing profiles
        or start with client creates and updates received from now. Existing Contact
        values are not overwritten.
      </Text>
      <Flex gap="2" wrap="wrap">
        {SEVENROOMS_PULL_FIELDS.map((field) => (
          <Badge key={field} size="1" variant="soft" color="gray">
            {field}
          </Badge>
        ))}
      </Flex>
      {!pushChecked && !pullChecked ? (
        <Text size="1" color="red">
          Enable at least one sync direction.
        </Text>
      ) : null}
    </div>
  );
}
